<template>
  <div>
    <span class="fold-icon-wrap" @click="changeFold">
      <span :class="`fold-icon ${!isFold ? 'open' : ''}`">
      </span>
      <b class="tips" v-if="isFold"></b>
    </span>

    <transition name="fadeIn">
      <div class="nav-wrap" v-show="!isFold">
        <div class="nav-box">
          <ul class="nav-list">
            <li v-for="(item, index) in nav" :key="index" class="nav-item">
              <a :href="item.url" target="_blank" class="nav-link">{{ item.name }}</a>
            </li>
          </ul>
        </div>
        <p class="contact-tel">
          合伙人热线<br />
          <a href="tel:400-000-0000">400-891-0589</a>
        </p>
      </div>
    </Transition>
  </div>
</template>
<script>
export default {
  data() {
    return {
      nav: [
        {
          name: '首页',
          url: '/'
        },
        {
          name: '品牌故事',
          url: '/brand_story'
        },
        {
          name: '产品展示',
          url: '/product'
        },
        {
          name: '品牌资讯',
          url: '/brand_info'
        },
        {
          name: '门店分布',
          url: '/store'
        },
        {
          name: '联系我们',
          url: '/contact'
        }
      ],
      isFold: true
    }
  },
  methods: {
    changeFold() {
      this.isFold = !this.isFold
    }
  }
}

</script>
<style lang="less" scoped>
@media (max-aspect-ratio: 3/2) {
  .nav-wrap {
    .contact-tel {
      font-size: 7.2vw !important;
      line-height: 7.2vw !important;
    }

    div.nav-box {
      width: 58.2vw !important;
      transform: translate(-50%, -50%) scale(0.8);
    }

    li.nav-item {
      height: 45.2vw !important;

      a.nav-link {
        font-size: 9.2vw !important;
        line-height: 9.2vw !important;
      }
    }
  }
}

@media(max-width: 1200px) {
  .contact-tel {
    bottom: 0.8vw !important;
    font-size: 11.2vw !important;
    line-height: 11.2vw !important;
  }

  .fold-icon-wrap {
    width: 10vw !important;
    top: 7vw !important;
    right: 14vw !important;
    height: 5vw !important;

    .fold-icon {
      width: 10vw !important;
      height: 5vw !important;
    }

    .tips {
      width: 24.8vw !important;
      height: 3.47vw !important;
      background-size: 100% auto;
      bottom: -4.8vw !important;
    }
  }

  .nav-box {
    width: 57.6vw !important;
  }

  .nav-wrap {
    width: 100vw !important;

    .nav-item {
      height: 55.2vw !important;
      width: 19.04vw !important;
      margin: 6.28vw 0 !important;

      a {
        font-size: 11.2vw !important;
        line-height: 19.04vw !important;
      }
    }
  }

}

.nav-wrap {
  width: 360px;
  background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/nav_bg.png) no-repeat top center;
  background-size: cover;
  position: fixed;
  height: 100vh;
  right: 0;
  top: 0;
  z-index: 100;
  font-family: hanli-min, Hl0811,Hl0906,Hl1126;
}

.fold-icon-wrap {
  position: fixed;
  top: 70px;
  right: 100px;
  width: 60px;
  height: 30px;
  cursor: pointer;
  z-index: 101;

  .tips {
    position: absolute;
    bottom: -32px;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0.8;
    background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/more_text.png) no-repeat top center;
    background-size: 100% auto;
    width: 143px;
    height: 20px;
  }
}

.fold-icon {
  background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/fold.png) no-repeat top center;
  width: 60px;
  height: 29px;
  background-size: 100%;
  display: block;

  &.open {
    background: url(https://ymf-static-resource.oss-cn-hangzhou.aliyuncs.com/fold_b.png) no-repeat top center;
    background-size: 100%;
  }
}

.nav-box {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 210px;
  overflow: hidden;
}

.nav-list {
  font-size: 40px;
  line-height: 68px;
  display: flex;
  width: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
  flex-wrap: wrap;
  flex-direction: row-reverse;

  li {
    padding: 0;
    margin: 0;
    height: 208px;
    border-left: 1px solid #473935;
    box-sizing: border-box;
    margin: 60px 0;
  }

  a {
    color: #473935;
    writing-mode: vertical-rl;
    text-decoration: none;
  }
}

.contact-tel {
  position: absolute;
  width: 100%;
  font-size: 40px;
  text-align: center;
  line-height: 26px;
  margin: 0;
  padding: 0;
  color: #473935;
  bottom: 70px;
  left: 0;

  a {
    letter-spacing: 3px;
    color: #473935;
  }
}
</style>